const en = {
  signin: "Login & Register",
  signout: "Logout",
  home: "Home",
  profile: "My Profile & Bookings",

  language: "Language",
  phone: "Phone Number",

  reserve: "Reserve",

  sms_verify_title: "Verify your account",
  sms_verify_desc: "OTP code has been sent to your number",

  alert_login_in: "Please login",

  or: "OR",
  continue: "Continue",
  continue_with_facebook: "Continue with Facebook",
  continue_with_google: "Continue with Google",

  bookings: "My Bookings",
  bookings_desc: "Booking History",
  approved: "Approved",
  pending: "Pending",
  cancelled: "Cancelled",

  profile_desc: "Earn Flying Points and redeem them for your next booking",
  profile_accumulate_hours: "Flying Hours",
  profile_card_point_used: "Point Redeemed",
  profile_pending_approval: "Pending",
  profile_upload_receipt: "Upload Receipt",
  profile_no_more: "-End-",

  profile_point_his_view_title: "Points History",
  profile_point_his_title: "Points History",
  profile_voucher: "Vouchers",
  profile_point_his_id: "Record ID",
  profile_point_his_date: "Redemption Date",
  profile_point_his_category: "Category",
  profile_point_his_quantity: "Quantity",
  profile_point_his_remarks: "Remarks",

  profile_point_his_system_distribution: "System Distribution",
  profile_point_his_system_promotion: "Promotional Offer",
  profile_point_his_system_redeem: "Flying Points Redemption",

  profile_update_title: "Update Personal Information",
  profile_update_title_big: "Personal Information",
  profile_update_change_image: "Change Profile Picture",
  profile_voucher_total: "Vouchers Available",
  profile_update_last_name: "Last Name",
  profile_update_first_name: "First Name",
  profile_update_email: "Email",
  profile_update_phone: "Phone",
  profile_update_btn: "Update",
  profile_update_success: "Update Success",
  profile_update_missing_fields: "Please fill in all required fields: {{fields}}.",
  profile_accept_terms: "By clicking 'Update', you agree to ",

  startTime: "Start Time",
  endTime: "End Time",
  totalTime: "Duration",
  total: "Total",

  days: "Days",
  minutes: "Minutes",
  hours: "Hours",
  expired: "Expired",
  soon: "Soon",
  done: "Completed",
  points: "Available Flying Points",

  showMore: "More",
  location: "Location",
  location_desc: "2min walk from Lai Chi Kok Station",
  amenities: "Amenities",
  amenities_desc: "About the property's amenities and services",
  review: "Session Review",
  review_desc: "Browse the available time",
  priceAndOpening: "Price & Opening hours ",
  priceAndOpening_desc: "Prices may increase on weekends or holidays",

  availability: "Choose your own period",
  availability_desc: "Select your preferred period and tailor your space experience according to your needs.",

  select_start_time: "Select start time",
  select_end_time: "Select end time",

  rules: "Terms & Conditions",
  cancel_policy: "Cancellation Policy",
  cancel_policy_desc:
    "We understand that plans may change, so please familiarize yourself with our cancellation policy. Planning ahead is wise, and you have the flexibility to cancel or modify your reservation within the specified timeframe. Please note that specific terms of the cancellation policy may vary based on your reservation type and selected package. We are committed to providing flexible options to ensure ease in managing changes to your plans.",
  venue_usage_policy: "Venue Guidelines",
  venue_usage_policy_desc:
    "To ensure a smooth experience for all users, please read and adhere to our venue guidelines carefully. These guidelines are designed to provide a safe, friendly, and comfortable environment, ensuring the rights and satisfaction of each participant. If you have any questions, feel free to contact our customer service, and we will be happy to assist you.",

  checkout_title: "Confirm Your Reservation",
  checkout_reservation_information: "Reservation information",
  checkout_reservation_information_desc: "Please review your reservation. Once approved, it may not be possible to make changes",
  checkout_point_redeem_badge: "This reservation will deduct",
  checkout_point_redeem_title: "Use Your Flying Points",
  checkout_point_redeem_desc: "Settle using Flying points from your account",
  checkout_point_redeem_label: "Accumulated Flying Points",
  checkout_point_redeem_btn: "Redeem",
  checkout_personal_info_required: "Please complete your profile before you can make a booking. Thank you:)",
  checkout_personal_info_required_btn_title: "Fill in Now",

  checkout_contact_title: "Contact Information",
  checkout_contact_email: "Email",
  checkout_contact_phone: "Phone",
  checkout_contact_remarks: "Remarks",

  checkout_confirm_btn: "Confirm Reservation",
  checkout_error_invalid_email: "Please enter a valid email address.",
  checkout_error_invalid_phone: "Please enter a valid phone number.",

  price_basic_charge: "Basic Charge",
  price_weekly_charges: "Weekly Charges",
  price_special_period: "Special Rate Period",
  per: " Per ",
  everyday: "Everyday",
  from: "From",
  to: "To",

  footer_alert_login: "Please login and proceed with the reservation",
  footer_alert_select_time: "Please select a time first before proceeding with the reservation",
  footer_login_now: "Login",

  pay_done_title: "Successful Booking",
  pay_done_booking_id: "Booking ID",
  pay_done_payment_method: "Payment Method",
  payment_method_fps: "FPS",
  payment_method_bank_transfer: "Bank Transfer",
  payment_goto_my_profile: "Goto Upload",

  pay_done_pending_title: "Booking Pending Confirmation",
  pay_done_success_title: "Booking Successful",
  payment_alert:
    "Please complete the transfer within 6 hours of booking and upload the screenshot of the transfer in 'My Profile and Bookings'. Otherwise, your booking will be automatically cancelled. Please take note.",
  pay_done_approved: "You can check your booking status in 'My Profile and Bookings'",
  pay_done_pending_admin_action: "Upload successful, please wait for confirmation",
  pay_done_upload_payment_title: "Please upload the payment proof as soon as possible so that we can process your booking.",
  pay_done_upload_payment_desc:
    "If you are unable to complete the payment and upload the proof by today or before the usage time, the booking will be cancelled. If you have any questions, please contact us.",

  copied: "Copied to clipboard",

  quick_selection: "Quick review",
  quick_selection_desc: "Availability",
  selection_unit: "Section",

  app_timeslot_occupied: "The selected timeslot includes already reserved or closed timeslots.",
  app_end_date_time_should_not_same_or_before_start_date_time: "The selected timeslots are invalid",

  invalid_start_time: "Start time cannot after end time",
  invalid_end_time: "End time cannot before start time",

  confirm: "Confirm",

  checkout_checkbox_desc: "I have read and agree to the",
  checkout_checkbox_error: "Please read and agree to the",
  terms: "Terms",
  and: "and ",
  disclaimer: "Disclaimer",
  personal_data_collection: "Personal Data Collection",
  all_terms: "All Terms and Disclaimer",

  packages: "Discount Packages",
  packages_home_desc: "Select a package that suits your needs",
  packages_period_title_1: "Validity",
  packages_period_title_2: "of this package",
  packages_items: "Items",
  packages_purchase: "Purchase",
  packages_cancel: "Cancel",
  packages_upload_proof: "Upload Proof",
  packages_proof_uploaded: "Proof uploaded, please wait for approval",

  cancellation_or_no_show_title: "Cancellation Or No Show Policy",
  cancellation_or_no_show_1:
    "Any single hour or package purchase is valid only for the term for which it is purchased. Please note all packages are valid for 2 months starting from the 1st practice booked. You may change any practice session at least 48 hours in advance. Any hours not used by the valid date cannot be rolled and will be lost.",
  cancellation_or_no_show_2:
    " In case of Typhoon Warning Signal No. 8 or above, or the Red/Black Rainstorm Warning is in force within 2 hours before the booking, the practice session can be rescheduled but not refunded.",
  cancellation_or_no_show_3: "We do not provide refunds if you change your mind or are unable to attend the practice sessions due to any reasons.",

  personal_data_collection_title: "Disclaimer Regarding Personal Data Collection",
  personal_data_collection_main:
    "Flying Lab is committed to safeguarding your personal data and ensuring compliance with the Personal Data (Privacy) Ordinance (Cap. 486) of Hong Kong. By providing your personal data, you acknowledge and agree to the following:",

  personal_data_collection_1_start: "1. Purpose of Data Collection: Your personal data will be collected for the following purposes:",
  personal_data_collection_1a: "when you visit our website or Instagram page",
  personal_data_collection_1b: "when you interact with us and use our venue and services",
  personal_data_collection_1_end: "We safely store your data locally or overseas, including in the cloud, and are responsible for keeping your data safe in compliance with Hong Kong law.",

  personal_data_collection_2: "2. Data Handling: We will handle your personal data in accordance with our privacy policy, which outlines how we collect, use, and protect your personal information.",

  personal_data_collection_3:
    "3. Direct Marketing: This is when we use your data to send you details about our venue, services, and offers provided by us or our co-branding, rewards or loyalty programme partners or charities. We may use data such as your demographics and booking behaviour when we market to you.",

  personal_data_collection_4: "4. Data Retention: Your personal data will be retained only for as long as necessary to fulfill the purposes for which it was collected, or as required by law.",

  personal_data_collection_5:
    "5. No Third-Party Sharing: We don’t give your data to others for them to market their products and services to you. If we ever wanted to do this, we’d get your separate consent, or unless required by law.",

  personal_data_collection_6:
    "6. Data Access and Correction: You have the right to request access to and correction of your personal data in accordance with the Personal Data (Privacy) Ordinance. If you wish to do so, please amend directly on the website or contact us on Instagram.",

  personal_data_collection_7:
    "7. Withdrawal of Consent: You may withdraw your consent for our use of your personal data at any time. However, please note that this will affect our ability to provide services to you.",

  personal_data_collection_footer: "By continuing to engage with Flying Lab and make your booking with us, you consent to the collection and use of your personal data as outlined in this disclaimer.",

  personal_data_collection_thanks: "Thank you for your trust.",

  disclaimer_title: "Disclaimer",
  disclaimer_1: "By entering Flying Lab (FL), you agree that FL is in no way responsible for any injury or loss caused during your practice or whilst participants are at or near the studio.",
  disclaimer_2:
    "You are responsible for ensuring that you are physically and medically fit for any equipment you are going to use. You must take care of your own personal safety at all times. Should you have a pre-existing medical condition or in doubt as to your suitability for practicing, we recommend you consult your physician for medical clearance.",
  disclaimer_3: "You must monitor the safekeeping of personal belongings during practice, as FL does not take responsibility for any lost or stolen property.",
  disclaimer_4:
    "You understand that the usage of poles or any aerial equipment may be physically strenuous and you voluntarily participate in them with full knowledge that there is risk of personal injury, property loss or death.",
  disclaimer_5:
    "You agree that you will not sue or make any other claims of any kind whatsoever against Flying Lab or its owners for any personal injury, property damage/loss, or wrongful death, whether caused by negligence or otherwise.",
  disclaimer_6:
    "You acknowledge and accept that FL is under 24-hour video surveillance. All recorded media is the sole property of FL. FL may pursue and claim compensation for any damage caused by you to the property or the equipment on the premises.",
  disclaimer_7: "You agree to not drink alcohol or take drugs prohibited by law before or during any practice.",
};

export default en;
